import SvgIcon from "./index.vue";

const svgIcon = {
  install: function (Vue) {
    // import all svg file
    const requireAll = (requireContext) =>
      requireContext.keys().map(requireContext);
    const req = require.context("../../../assets/icon/svg", true, /\.svg$/);
    requireAll(req);

    Vue.component("SvgIcon", SvgIcon);
  },
};

export default svgIcon;
